import React, { useEffect, useState } from "react";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import useHttp from '../../../../../hook/use-http';
import { API_URL_MAIN } from '../../../../../constants/driveglobalfilterinitalstates_bus';
import { decodeToken } from "react-jwt";
import { useLocation } from 'react-router-dom';

const Multicustomselectgrowth = ({ IND, filterdata, apiEnd, clearFilters = "", onChange, lable }) => {
  let location = useLocation();
  let path_check = location.pathname;
  const lastSegment = path_check.split("/").pop();

  const tokenNew = JSON.parse(sessionStorage.user);
  let decodedToken = decodeToken(tokenNew.token);
  const city_name = decodedToken.city_name;
  const depo_name = decodedToken.depo_name;

  const { sendReq: fetchData } = useHttp();
  const [loadedOption, setLoadedOption] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]); // Keep as array for UI compatibility
  const [disableInput, setDisableInput] = useState(false);
  const [disableInputValue, setDisableInputValue] = useState("");

  const appyData = (data) => {
    const res_result = data.unique_vehicles.buckets;
    const response = [];

    if (res_result.length !== 0) {
      let newRes = res_result.map(item => ({
        id: item.key.value,
        value: item.key.value,
        label: item.key.value
      }));
      response.push(...newRes);
    }

    // Remove "All" option for single select
    const finalOptions = response;

    setLoadedOption(finalOptions);
    setSelectedOptions([]);
    if (onChange) onChange([]);
  };

  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + `growth_tracking/${apiEnd}`,
        body: { IND, filterdata },
      },
      appyData
    );
  }, [filterdata.CITY, filterdata.DEPO, clearFilters, apiEnd]);

  const handleChange = (value, event) => {
    // For single selection: only keep the last selected item
    if (event.action === "select-option") {
      const newSelection = [event.option];
      setSelectedOptions(newSelection);
      onChange(newSelection);
    } else if (event.action === "deselect-option") {
      setSelectedOptions([]);
      onChange([]);
    } else if (event.action === "clear") {
      setSelectedOptions([]);
      onChange([]);
    }
  };

  const getDropdownButtonLabel = ({ placeholderButtonLabel, value }) => {
    if (!value.length) return "Select...";
    return value[0].label; // Show the selected item's label
  };

  return (
    <>
      <span className="select_col_title_bus">{lable}</span>
      {disableInput ? (
        <input
          autoComplete="off"
          className="top-filter filter-col"
          value={disableInputValue}
          disabled
        />
      ) : (
        <ReactMultiSelectCheckboxes
          className="react-select-container"
          classNamePrefix="react-select"
          options={loadedOption}
          placeholderButtonLabel={lable}
          getDropdownButtonLabel={getDropdownButtonLabel}
          value={selectedOptions}
          onChange={handleChange}
          isMulti // Keep this as true to maintain checkbox UI
        />
      )}
    </>
  );
};

export default Multicustomselectgrowth;
